<template>
    <div id="versand" v-if="getcurrent">
        <span>
            * <template v-if="shownetprices">
                    {{ $translate("Ceres::Template.singleItemExclVAT") }}
            </template>
            <template v-else>
                {{ $translate("Ceres::Template.singleItemInclVAT") }}
            </template>
            {{ $translate("Ceres::Template.singleItemExclusive") }}<a  :href="url" target="_blank"> {{ $translate("Ceres::Template.singleItemShippingCosts") }}</a>
        </span>
    </div>
</template>

<script>

    export default
    {
        props:['shownetprices',"url"],
        inject:
            {
                itemId:
                    {
                        default: null
                    }
            },
        methods:
            {

                currentVariation: function()
                {
                    return this.$store.getters[`${this.itemId}/currentItemVariation`];
                },
            },
        computed:
            {
                lang:function()
                {
                    return App.language;
                },
                shippingCountryId:function()
                {
                    return App.initialData.shippingCountryId
                },
                getcurrent: function()
                {
                    return this.currentVariation();
                },

            }
    }
</script>
